import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ConfigurationUnitPage } from './configuration-unit';
import { ConfigurationUnitAddPage } from './configuration-unit-add/configuration-unit-add';
import { ConfigurationUnitEditPage } from './configuration-unit-edit/configuration-unit-edit';

@NgModule({
  declarations: [ConfigurationUnitPage, ConfigurationUnitAddPage, ConfigurationUnitEditPage],
  imports: [IonicPageModule.forChild(ConfigurationUnitPage), TranslateModule.forChild()],
  entryComponents: [ConfigurationUnitAddPage, ConfigurationUnitEditPage],
})
export class ConfigurationUnitPageModule {}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-unit/configuration-unit.module.ts